// extracted by mini-css-extract-plugin
export default {"msgM":"_376efe7c4e"};